export default __webpack_public_path__ + "static/media/Group9192.90fc2e85.svg";